import React from 'react';
import styled from 'astroturf/react';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextTruncate from 'react-text-truncate';

import { MarketingVideo } from '../../shared/course_helper';

export interface PlaylistProps {
  videos: MarketingVideo[];
  videoCount: number;
  duration: string;
}

const Container = styled.div``;

const Heading = styled.h5`
  @import '../../shared/mixins.scss';
  @include headingH5();
  @include textSecondary();
  margin-top: 0;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

const Summary = styled.h4`
  @import '../../shared/mixins.scss';
  @include bodyLargeBold();
  @include textSecondary();
  margin-top: 0;
  margin-bottom: 20px;
`;

const Videos = styled.div`
  display: grid;
  grid-template-columns: [icon-start] min-content [bullet-start] min-content [title-start] 1fr [duration-start] min-content;
  grid-row-gap: 18px;
`;

const Icon = styled.div`
  grid-column-start: icon-start;
  font-size: 13px;
  color: #b29a43;
  margin-right: 9px;
  line-height: 18px;
`;

const Order = styled.div`
  @import '../../shared/mixins.scss';
  @include bodyMediumRegular();
  @include textSecondary();
  grid-column-start: bullet-start;
  margin-right: 4px;
  text-align: right;
`;

const VideoTitle = styled.div`
  @import '../../shared/mixins.scss';
  @include bodyMediumRegular();
  @include textSecondary();
  grid-column-start: title-start;
  margin-right: 2px;
`;

const VideoDuration = styled.div`
  @import '../../shared/mixins.scss';
  @include bodyMediumRegular();
  @include textSecondary();
  text-align: right;
`;

const Playlist: React.FunctionComponent<PlaylistProps> = ({
  videos,
  videoCount,
  duration,
}) => (
  <Container>
    <Heading>Course videos</Heading>
    <Summary>
      {videoCount} videos{duration ? `, ${duration}` : ''}
    </Summary>
    <Videos>
      {videos.map((video) => (
        <React.Fragment key={video.id}>
          <Icon>
            <FontAwesomeIcon icon={faLock} />
          </Icon>
          <Order>{video.numbering && `${video.numbering}.`}</Order>
          <VideoTitle>
            <TextTruncate
              line={2}
              truncateText="…"
              text={video.title}
              //@ts-ignore
              title={video.title}
            />
          </VideoTitle>
          <VideoDuration>{video.duration}</VideoDuration>
        </React.Fragment>
      ))}
    </Videos>
  </Container>
);

export default Playlist;
